const actions = {
  REQUESTING: 'Deficiencys/REQUESTING',
  RESPONSE_ERROR: 'Deficiencys/RESPONSE_ERROR',

  FETCH_DEFICIENCYS: 'Deficiencys/FETCH',
  LIST_DEFICIENCY: 'Deficiency/LIST',

  FETCH_DEFICIENCY: 'Deficiency/FETCH',
  NEW_DEFICIENCY: 'Deficiency/NEW',
  EDIT_DEFICIENCY: 'Deficiency/EDIT',
  RESET_DEFICIENCY: 'Deficiency/RESET',

  RE_FETCH_DEFICIENCYS: 'Deficiencys/REFRESH',
  SAVE_DEFICIENCY: 'Deficiency/SAVE',
  SAVE_DEFICIENCY_RECIEVED: 'Deficiency/SAVE_DEFICIENCY_RECIEVED',

  DELETE_DEFICIENCY: 'Deficiency/DELETE',
  DELETE_DEFICIENCY_RECIEVED: 'Deficiency/DELETE_RECIEVED',
}

export default actions
